import React from 'react'
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { Guardian } from '@xaamin/guardian';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const TimbradoMasivoListActions = (props) => {

  return (
    <>
      { Guardian.allows('facturacion.masiva.subir.archivo') && (
        <Button as={ Link } className="mr-2" to="/modulos/timbrado-masivo/archivos/upload">
          Subir archivo
        </Button>
      )}

      <Button variant="link"
        as={ Link }
        className="text-secondary"
        to="/modulos/timbrado-masivo/tickets"
      >
        Tickets { ' ' }
        <FontAwesomeIcon icon={ ['fas', 'chevron-right'] } />
      </Button>

    </>
  )
}

export default TimbradoMasivoListActions;